import React from "react";
import { useHistory } from "react-router-dom";

const useEtaSwitcher = () => {
  const history = useHistory();

  const setLocation = (location) => {
    history.push(location);
  };

  return {
    setLocation,
  };
};

const EtaSwitcher = (props) => {
  const { setLocation } = useEtaSwitcher();

  return (
    <div className="level-item">
      <div className="select is-medium">
        <select
          onChange={(event) => setLocation(event.target.value)}
          value={props.checked}
        >
          <option value="/eta/sos">Fuentes de suministro</option>
          <option value="/eta/branches">Sucursales</option>
        </select>
      </div>
    </div>
  );
};

export default EtaSwitcher;
